import { createIconComponent } from '../../factory/create-icon-component';
export const SendIcon = createIconComponent(
  'SendIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.2757 9.13784L9.03859 4.0193C6.04164 2.52082 4.54316 1.77158 3.76542 2.02258C3.09409 2.23924 2.58655 2.79354 2.42974 3.48131C2.24806 4.2781 3.12611 5.70492 4.8822 8.55857L5.96793 10.3229C6.34266 10.9318 6.53003 11.2363 6.60315 11.5622C6.66781 11.8505 6.66781 12.1495 6.60315 12.4378C6.53003 12.7637 6.34266 13.0682 5.96793 13.6771L4.8822 15.4414C3.12611 18.2951 2.24806 19.7219 2.42974 20.5187C2.58655 21.2065 3.09409 21.7608 3.76542 21.9774C4.54316 22.2284 6.04162 21.4792 9.03856 19.9807L9.03858 19.9807L19.2757 14.8622C21.1181 13.941 22.0393 13.4803 22.3349 12.857C22.5922 12.3146 22.5922 11.6854 22.3349 11.143C22.0393 10.5197 21.1181 10.059 19.2757 9.13784Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 12H11"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
